export default {
  'name':	'Exhibitor',
  'enName': 'Exhibitor(English name)',	
  'address': 'Address',
  'enAddress': 'English',
  'country': 'Country',
  'province': 'Province',
  'city': 'City',
  'zipCode': 'Post code',
  'companyScale': 'Company Scale',
  'registeredCapital': 'Registered Capital',
  'attendTimes': 'Times of attendance',
  'advertsVideo': 'Videos',
  'advertsImage': 'Pictures',
  'listed': 'Listed or no',
  'exhibitionFloor': 'Exhibition Hall',
  'exhibitionBoothPart': 'Exhibitor booth area',
  'exhibitionBoothNumber': 'Exhibitor booth No.',
  'itemIntroduction': 'Introduction of Exhibit',
  'webUrl': 'Website',
  'brand': 'Brand',
  'introduction': 'Introduction of company',
  'enIntroduction': 'English intriduction',
  'fax': 'Fax',
  'telephone': 'Tel',
  'email': 'Company email',
  'linkName': 'Exhibitor Contact ',
  'linkMobile': 'Exhibitor mobile',
  'linkEmail': 'Exhibitor email',
  'linkName1': 'Exhibitor conference contact',
  'linkMobile1': 'Exhibitor conference mobile',
  'linkEmail1': 'Exhibitor conference email',
  'yes': 'Yes',
  'no': 'No',
  'url3d': '3D URL',

  'companyTip': 'Quality image brings trust',
  'companyTip2': 'Clean and professional pictures can create a good impression and show strength',
  'companyTip3': 'Can include but not limited to the following',
  'companyTip4': 'Elegant office environment',
  'companyTip5': 'Advanced factory equipment',
  'companyTip6': 'Tidy and orderly storage',
  'uploadTip': 'Uploaded here is a corporate image, please upload according to the company’s situation',
  'uploadTip2': 'No less than 1200*560 pixel, supports png, jpg format, not more than 2Mb, you can upload up to three product Images.',
  'companyTitle': 'Upload promotional video',
  'companyTip7': 'Broadcast corporate image',
  'companyTip8': "Promote the audience's understanding of the company, enhance the added value of the company's brand, expand its influence, and reach a consensus",
  'uploadTip3': 'The best display effect can be obtained when the video cover and video are widescreen',
  'btnText': 'Add tags',
  'companyTip9': 'Accurately select exhibitor labels to help you match high-quality buyers more accurately',
  'companyTip10': 'The company logo uploaded here, please upload according to the company VI',
  'companyTip11': 'The best effect is to display in the center within the range of 200*200px, please ensure that the proportion of the logo image is not distorted',
  'companyTip13': 'supports png, jpg format, not more than 2Mb',
  'exhInfo1': 'The information you uploaded can be sent to the intended audience via IM live chat.',
  'exhInfo2': 'Notice: support png, jpg format pictures, PDF, Word, Excel, PPT format files, MP4, MOV format video, no more than 10Mb'
}
